import { render, staticRenderFns } from "./AboutESGBody.vue?vue&type=template&id=48c07917&scoped=true&"
import script from "./AboutESGBody.vue?vue&type=script&lang=js&"
export * from "./AboutESGBody.vue?vue&type=script&lang=js&"
import style0 from "./AboutESGBody.vue?vue&type=style&index=0&id=48c07917&scoped=true&lang=scss&"
import style1 from "./AboutESGBody.vue?vue&type=style&index=1&id=48c07917&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c07917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c07917')) {
      api.createRecord('48c07917', component.options)
    } else {
      api.reload('48c07917', component.options)
    }
    module.hot.accept("./AboutESGBody.vue?vue&type=template&id=48c07917&scoped=true&", function () {
      api.rerender('48c07917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/AboutESG/AboutESGBody.vue"
export default component.exports